export default function isHttpStatusOK(status) {
  /** Httpステータスコードが2xxか判定します。 */
  return status >= 200 && status < 300;
}
